// extracted by mini-css-extract-plugin
export default {"button":"Button_button__vXTWK","disableButton":"Button_disableButton__KCwE7"};